import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './About.css';

function About() {
  const [gridRef, gridVisible] = useScrollReveal();

  return (
    <section className="about section" id="about">
      <div className="container">
        <div ref={gridRef} className={`about__grid reveal ${gridVisible ? 'visible' : ''}`}>
          <div className="about__image-wrapper">
            <div className="about__image-frame">
              <img
                src="/images/miriam-portrait-1.jpg"
                alt="Miriam Haart"
                className="about__image"
              />
            </div>
            <div className="about__image-accent" />
          </div>
          <div className="about__content">
            <h2 className="about__title">
              About 
            </h2>
            <p className="about__bio">
              Miriam Haart is a technologist, author and activist with over{' '}
              <a href="http://instagram.com/miriamhaart" target="_blank" rel="noopener noreferrer" className="about__link">400K followers</a>.
              She started coding at 13, became an AI engineer in Silicon Valley at 17, and
              at 19 made history as the{' '}
              <a href="https://stanforddaily.com/2019/02/05/qa-cs-teacher-miriam-haart-22-discusses-the-impact-of-computer-science/" target="_blank" rel="noopener noreferrer" className="about__link">youngest lecturer</a> in Stanford's Computer Science Department.
            </p>
            <p className="about__bio">
              Today, Miriam is the CEO and Founder of{' '}
              <a href="http://actionai.co/" target="_blank" rel="noopener noreferrer" className="about__link">ActionAI</a>, a company revolutionizing
              Reliable, Trustworthy AI with offices in the US, Israel, Egypt, and the UAE.
            </p>
            <p className="about__bio">
              Her latest TED talk, "The SITT Test: Are You Really Thinking Freely?", explores
              modern society's shift towards fundamentalist thinking, drawing from her own
              upbringing in an ultra-religious community. She is a member of the de-radicalization
              delegation with the Emma Lazarus Institute and the Abraham Accords Institute in
              Berlin, an iCenter Fellow in Middle Eastern Studies, and a recipient of the
              Z-Fellowship.
            </p>
            <p className="about__bio">
              Miriam stars in the Netflix hit{' '}
              <a href="https://www.netflix.com/title/81175724" target="_blank" rel="noopener noreferrer" className="about__link"><em>My Unorthodox Life</em></a>.
              Her content spans AI innovation, Jewish and Middle Eastern activism, politics,
              female tech leadership, and motivation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
